import { combineReducers } from "redux";

function AgentsReducer() {
  const agentsInitialState = {
    error: null,
    loading: false,
    records: null,
  };

  const agents = (state = agentsInitialState, action) => {
    const { type, payload } = action;

    switch (type) {
      case "GET_AGENTS_INIT":
        return {
          ...state,
          loading: true,
          error: null,
          records: null,
        };
      case "GET_AGENTS_SUCCESS":
        return {
          ...state,
          loading: false,
          error: null,
          records: payload,
        };
      case "GET_AGENTS_ERROR":
        return {
          ...state,
          loading: false,
          error: payload,
          records: null,
        };
      default:
        return state;
    }
  };

  return combineReducers({
    agents,
  });
}

export default AgentsReducer();
